import { useState } from 'react';
import { supabase } from '../../supabase/client';
import LoginOptionsOverlay from './LoginOptionsOverlay';
import logo from '../../images/circle_fertility_partners_logo_c_t.png';

function AuthScreen() {
  const [showLoginOverlay, setShowLoginOverlay] = useState(false);
  const [busy, setBusy] = useState(false);

  const signInWithGoogle = async () => {
    setBusy(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin },
    });
    setBusy(false);
    if (error) throw error;
  };

  const signInWithApple = async () => {
    setBusy(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'apple',
      options: { redirectTo: window.location.origin },
    });
    setBusy(false);
    if (error) throw error;
  };

  const signUpAnonymously = async () => {
    setBusy(true);
    const randomId = Math.random().toString(36).substring(2, 15);
    const email = `anon_${randomId}@makebabies.local`;
    const password = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: window.location.origin,
        data: {
          is_anonymous: true,
        },
      },
    });
    setBusy(false);
    if (error) throw error;
  };

  const signInWithEmail = async (email, password, onError) => {
    setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) onError(error.message);
  };

  const signUpWithEmail = async (email, password, onError) => {
    setBusy(true);
    const { error } = await supabase.auth.signUp({ email, password });
    setBusy(false);
    if (error) onError(error.message);
    else onError('Check your email for confirmation link!');
  };

  const sendCode = async (phone, onError) => {
    setBusy(true);
    const { error } = await supabase.auth.signInWithOtp({ phone });
    setBusy(false);
    if (error) onError(error.message);
  };

  const verifyCode = async (phone, code, onError) => {
    setBusy(true);
    const { error } = await supabase.auth.verifyOtp({ phone, token: code, type: 'sms' });
    setBusy(false);
    if (error) onError(error.message);
  };

  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-start bg-gradient-to-br from-[#bfdbfe] to-[#fce7f3] px-6 pt-12">
      <div className="mb-8 flex flex-col items-center gap-4 text-center">
        <div className="flex aspect-square w-[70%] max-w-[280px] items-center justify-center rounded-3xl bg-gradient-to-br from-baby-blue to-baby-blue/80">
          <img src={logo} alt="Logo" className="h-[75%] w-[75%] drop-shadow-lg" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground tracking-tight">
            Welcome to
            <br />
            Circle Fertility Partners
          </h1>
          <p className="text-base text-muted-foreground font-medium">Sign in to stay in the loop</p>
        </div>
      </div>

      {!showLoginOverlay && (
        <button
          onClick={() => setShowLoginOverlay(true)}
          className="w-full max-w-xs rounded-3xl bg-[#469cff] px-6 py-3 text-sm font-semibold text-primary-foreground shadow-lg blur-window hover:bg-[#469cff]/80 hover:scale-105 transition-all duration-200"
        >
          Easy sign-in
        </button>
      )}

      {showLoginOverlay && (
        <LoginOptionsOverlay
          onClose={() => setShowLoginOverlay(false)}
          onSignInWithGoogle={signInWithGoogle}
          onSignInWithApple={signInWithApple}
          onSignUpAnonymously={signUpAnonymously}
          onSignInWithEmail={signInWithEmail}
          onSignUpWithEmail={signUpWithEmail}
          onSendCode={sendCode}
          onVerifyCode={verifyCode}
          busy={busy}
        />
      )}
    </div>
  );
}

export default AuthScreen;
